// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"730":"948c5504","1651":"96275d5e","1764":"0251edbb","1975":"96275d5e","2040":"daf69e74","5767":"96275d5e","7019":"daf69e74","7948":"daf69e74"}[chunkId] + ".chunk.css";
};